import useError from '@/hooks/useError';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import useToasts from '@/shared/hooks/useToasts';
import { MessageType } from '@/shared/hooks/useToasts.types';

const useCreateScope: any = () => {
  const addError = useError();
  const [{ loading }, makeRequest] = useImperativeRequestWrapper('lpVillage');
  const successMsg = useToasts((state) => state.addItem);

  const createScope = async (scope) => {
    const { error } = await makeRequest({
      path: '/admin/scopes',
      method: 'post',
      body: scope,
    });
    if (error) {
      addError(error);

      return { success: false };
    }
    successMsg(
      { msg: 'The scope was successfully added', type: MessageType.Success },
      'root',
      {}
    );

    return { success: true };
  };

  return [{ loading }, createScope];
};
export default useCreateScope;
